import React, { useEffect } from 'react';
import LnatLandingPage from '../../features/specialty/lnat';

export default function LnatLandingRoute() {
  useEffect(() => {
    document.title = "LNAT Law Prep 2026/2027 — Oxford, UCL, KCL & LSE Admissions | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <LnatLandingPage />;
}
